import configs from "configs";

export default {
  API_URL: configs.REACT_APP_SERVER_URL,
  FIlE_UPLOAD: `${configs.FILE_IMAGE_URL}`,
  FILE_DOWNLOAD: `${configs.FILE_DOWNLOAD_URL}`,
  PUBLIC_URL: `${configs.REACT_APP_PUBLIC_URL}`,
  // CMS Api url
  PRIVACY_POLICY: "PRIVACY_POLICY",

  // Posts api url
  POSTS: "posts",

  // Auth api url
  LOGIN: "admin/login",

  SEND_OTP: "admin/send-otp",

  VERIFY_OTP: "admin/verify-otp",
  LOGOUT: "admin/logout",

  REFRESH_TOKEN: "admin/refresh-access-token",

  FORGOT_PW: "admin/forgot-password",
  SEND_DELETE_ACCOUNT_OTP: "user-account-delete",
  VERIFY_DELETE_ACCOUNT_OTP: "user-account-delete-verify",
  PRIVACY_POLICY: "privacy-policy",

  RESET_PW: "admin/reset-password",

  GET_COLUMN_TABLE_SETTINGS: "admin/table-column-settings",

  // User profile url
  PROFILE: "admin/profile",
  IMAGE_UPLOAD: "admin-user/file-upload",
  EDIT_PROFILE: "admin/edit-profile",
  FILE_UPLOAD: "admin/image-file-upload",
  MULTIPLE_FILE_UPLOAD: "admin/multiple/image-file-upload",
  MULTIPLE_VIDEO_UPLOAD: "admin/multiple/video-file-upload",
  MULTIPLE_DOCUMENT_UPLOAD: "admin/multiple/document-file-upload",
  ADD_PROPERTY_DOCUMENT: "/admin-property/add-document",
  CHANGE_PASSWORD: "admin/change-password",
  GLOBAL_CONFIG: "admin/global-config",
  DELETE_PROFILE: "admin",

  // Master => Timezone
  TIMEZONE: "master/timezone",
  TIMEZONE_LIST: "master/timezone/listing",
  // Master => Country
  COUNTRY: "master/country",
  CURRENCY_LIST: "master/currency",
  // Master => Language
  LANGUAGE: "master/language",
  GET_LANGUAGE: "master/language/listing",
  AMENITIES_LIST: "master/amenity",
  INDUSTRY_LIST: "master/industry",
  PROPERTY_TYPE_LIST: "master/property-type",
  SUBSIDIARY_LIST: "master/subsidiary",
  ROLE_LIST: "master/employment-role",
  GEMSTONE_TYPE_LIST: "master/gemstone-type",
  PROPERTY_TYPE_LIST: "master/property-type",

  //  settings
  META_DATA: "settings/general/meta-data",
  SITE_SETTING: "settings/general/site-settings",
  DATE_TIME: "settings/general/date-time",
  ANALYTICAL_DATA: "settings/general/analytical-data",
  SITE_UN_MAINTENANCE: "settings/general/site-un-maintenance",
  SOCIAL_MEDIA_SDK: "settings/social-media/social-media-sdk",
  SOCIAL_MEDIA_LINK: "settings/social-media/social-media-link",
  CHANGE_STATUS: "settings/social-media/sdk",
  SMTP_DETAILS: "settings/smtp",
  SMS_DETAILS: "settings/sms",
  NOTIFICATION: "settings/email-settings/notifications",
  LANGUAGE_MESSAGES: "settings/language-preferences/messages",
  LANGUAGE_LABEL: "settings/language-preferences/label",
  ADD_EDIT_PAYMENT: "settings/payment-gateway",
  TWO_WAY_AUTHENTICATION: "settings/general/change-2fa-status",
  GET_TWO_WAY_AUTHENTICATION: "settings/general/get-2fa",
  //role
  GET_ALL_PERMISSSION: "role/get-all-permission",
  ROLE: "role",
  CHANGE_ROLE: "/role/change-role",
  ROLE_LISTING: "role/listing",
  USER_LIST: "role/user-list",

  //emailTemplates
  LISTING: "email-template/listing",
  STATUS_CHANGE: "email-template/change-status",
  EMAIL_TEMPLATES: "email-template",

  //blog
  BLOG_CATEGORY_LISTING: "blog-categories/listing",
  BLOG_CATEGORY: "blog-categories",
  BLOG_CATEGORY_LIST: "blog-categories/dropdown",
  BLOG_LIST: "blog/listing",
  BLOG: "blog",
  BLOG_LIST_DOWNLOAD: "blog/download",
  BLOG_PUBLISH: "blog/publish",
  BLOG_CATEGORY_DOWNLOAD: "blog-categories/download",

  //faq
  FAQ_LISTING: "faq",
  FAQ: "faq",

  //users
  LISTING_ADMIN_MANAGEMENT: "admin-management",
  ADMIN_MANAGEMENT: "admin-management",
  LISTING_USER_MANAGEMENT: "admin-user/listing",
  ADMIN_USERS_DOWNLOAD: "admin-management/download",
  USER_MANAGEMENT_DOWNLOAD: "admin-user/download",
  USER_MANAGEMENT_STATUS_UPDATE: "/admin-user/status",
  USER_MANAGEMENT_DELETE: "admin-user/delete",
  USER_MANAGEMENT: "admin-user",
  USER_DETAILS_DOWNLOAD: "admin-user/download",
  INDIVIDUAL_USER_DETAILS: "admin-user/details",
  INDIVIDUAL_USER_DETAILS_INCOME_INFORMATION: "admin-user/incomeInformation",
  INDIVIDUAL_USER_DETAILS_PERSONAL_DETAILS: "admin-user/personals/listing",
  INDIVIDUAL_USER_DETAILS_PERSONAL_SINGLE_DETAILS:
    "admin-user/personals/details",
  INDIVIDUAL_USER_DETAILS_DOCUMENTS_UPLOAD: "admin-user/documents/file-upload",
  INDIVIDUAL_USER_DETAILS_DOCUMENTS: "admin-user/documents",
  INDIVIDUAL_USER_DETAILS_DOCUMENTS_ADD: "admin-user/add-documents",
  INDIVIDUAL_USER_DETAILS_DOCUMENTS_EDIT: "admin-user/update-documents",
  INDIVIDUAL_USER_DETAILS_DOCUMENTS_DELETE: "admin-user/documents",
  INDIVIDUAL_USER_DETAILS_BANK_ACCOUNTS: "admin-user/bank-accounts/listing",
  INDIVIDUAL_USER_DETAILS_INVESTMENTS: "admin-user/investments/listing",
  INDIVIDUAL_USER_DETAILS_DEPOSITS: "admin-user/deposits/listing",
  INDIVIDUAL_USER_DETAILS_WITHDRAWALS: "admin-user/withdrawals/listing",
  INDIVIDUAL_USER_RISKMETER: "admin-user/risk-meter",
  INDIVIDUAL_USER_RETURNS: "admin-user/returns/listing",
  INDIVIDUAL_USER_RETURNS_STATISTICS: "admin-user/returns/statistics",
  INDIVIDUAL_USER_TIME_LINE: "admin-user/timeline/listing",
  USER_APPROVAL_STATUS_UPDATE: "admin-user/account-type-status",
  USER_KYC_HISTORY_LISTING: "admin-user/kyc",
  USER_KYC_STATUS_UPDATE: "admin-user/update-kyc",
  UPDATE_BUSINESS_CUSTOM_USER_DOCUMENT: "admin-user/add-custom-documents",

  //Static page management
  STATIC_PAGE_MANAGEMENT_LISTING: "static-page",
  STATIC_PAGE_MANAGEMENT: "static-page",
  STATIC_PAGE_MANAGEMENT_DOWNLOAD: "staticPage/download",

  //Commom Filter API
  SAVE_FILTER: "common/filter",
  SAVE_COLUMN: "common/column",
  //Language
  GET_LANGUAGE: "/master/language/listing",
  //Support
  SUPPORT: "support",
  SUPPORT_REPLY: "support/reply",
  CONFIGURATION_LIST: "admin-configuration",
  CONFIGURATION_SAVE: "admin-configuration",
  NOTIFICATION_LIST: "/admin/notifications/listing",
  NOTIFICATION_LIST_CHANGE_STATUS: "/admin/notifications",

  //property
  PROPERTY: "/admin-property/property",
  GET_PROPERTY_DETAILS: "/admin-property/property-details",
  PROPERTY_LISTING: "/admin-property/property-listing",
  PROPERTY_ADD: "/admin-property/add-details",
  PROPERTY_EDIT: "/admin-property/edit-details",
  PROPERTY_DELETE: "/admin-property/delete-property",
  PROPERTY_DOWNLOAD: "/admin-property/download",
  PROPERTY_IMAGE_GALLERY: "/admin-property/add-gallery",
  PROPERTY_IMAGE_GALLERY_EDIT: "/admin-property/edit-gallery",
  GET_PROPERTY_IMAGE_GALLERY: "/admin-property/property-gallery",
  PROPERTY_VIDEO_GALLERY: "/admin-property/add-gallery",
  PROPERTY_COST_CONSTANTS: "/admin-property/add-cost-constants",
  EDIT_PROPERTY_COST_CONSTANTS: "/admin-property/edit-cost-constants",
  DELETE_PROPERTY_COST_CONSTANTS: "/admin-property/delete-cost-constants",
  GET_PROPERTY_COST_CONSTANTS: "/admin-property/cost-constants",
  DELETE_PROPERTY_GALLERY: "/admin-property/delete-gallery-image",
  CONTACT_LIST: "/admin/contact-us",
  PROPERTY_GENERAL_OPTIONS: "/admin-property/property-dropdown",
  PROPERTY_INVESTMENT_LIST: "/admin-property/investments-listing",
  PROPERTY_DIVIDEND_LIST: "/admin-property/dividends-listing",
  PROPERTY_SALE_PROCEED_LIST: "/admin-property/sale-proceeds-listing",
  PROPERTY_SALE_PROCEED_NOTIFICATION_LIST:
    "/admin/property-sale-proceed-notifications",
  ADD_SALE_PROCEED_NOTIFICATION_LIST:
    "/admin/property-sale-proceed-notifications",

  //Invesments
  INVESMENTS: "admin/investment/listing",
  INVESMENTS_DETAIL: "admin/investment/details",
  INVESMENTS_USER: "admin/investment/user-listing",
  INVESMENTS_DOWNLOAD: "admin/investment/download",
  INVESMENTS_SUMMARY: "admin/invest-summary",
  INVESTMENT_UPDATE_DETAILS: "admin/invest-request",
  //valuation
  ADD_PROPERTY_VALUATION: "/admin-property/add-valuation",
  GET_PROPERTY_VALUATION: "/admin-property/valuation",
  EDIT_PROPERTY_VALUATION: "/admin-property/edit-valuation",
  LIST_PROPERTY_VALUATION: "/admin-property/valuation-listing",
  DELETE_PROPERTY_VALUATION: "/admin-property/delete-valuation",

  //document
  PROPERTY_DOCUMENT: "/admin-property/add-document",
  GET_PROPERTY_DOCUMENT_LIST: "/admin-property/document-listing",
  DELETE_PROPERTY_DOCUMENT: "/admin-property/delete-document",

  //deposits
  DEP: "/admin/deposits",
  DEP_DOWNLOAD: "/admin/deposits/download",
  //withdrawal
  WITHDRAWAL: "/admin/withdrawals",
  WITHDRAWAL_DOWNLOAD: "/admin/withdrawals/download",

  //dividend
  DIVIDEND: "/admin/property-dividends",
  DIVIDEND_USER: "/admin/property-dividends-add-dividends-listing",
  DIVIDEND_DOWNLOAD: "/admin/property-dividends/download",

  //saleProceed
  SALE_PROCEED: "/admin/property-saleProceed",
  SALE_PROCEED_UPDATE_STATUS: "/admin/update-saleProceed-status",
  SALE_PROCEED_DETAILS: "/admin/property-saleProceed-details",
  SALE_PROCEED_USER: "/admin/sale-proceed-add-dividends-listing",
  SALE_PROCEED_INVESTMENT_LIST: "/admin/property-saleProceed-investments-list",
  PROPERTY_SALE_PROCEED_OPTIONS: "/admin/property-saleProceed-list",
  SALE_PROCEED_LIST_DOWNLOAD: "/admin/property-sale-proceed/download",
  SALE_PROCEED_NOTIFICATION_LIST_DOWNLOAD:
    "/admin/property-sale-proceed-notifications/download",
  //exitWindow
  EXIT_WINDOW: "/admin/exit-window",
  EXIT_WINDOW_SELL_REQUESTS: "/admin/exit-window-sell-requests",
  EXIT_WINDOW_PROPERTY_DETAILS: "/admin/exit-window",
  EXIT_WINDOW_PURCHASE_REQUESTS: "/admin/exit-window-purchase-requests",
  EXIT_WINDOW_SELLER_DETAILS: "/admin/exit-window-seller-details",
  EXIT_WINDOW_DOWNLOAD: "/admin/exit-window/download",
  EXIT_WINDOW_SELLER_DOWNLOAD: "/admin/exit-window-sell-requests/download",
  EXIT_WINDOW_PURCHASE_DOWNLOAD:
    "/admin/exit-window-purchase-requests/download",
  EXIT_WINDOW_STAKE_DETAILS: "/admin/exit-window-stake-detail",
  EXIT_WINDOW_PURCHASE_REQUESTS_DETAILS: "/admin/exit-window/stake-purchase",

  //Archived User
  ARCHIVED_USER: "admin-user/archived-listing",

  //Daily User Report
  USER_DAILY_REPORT: "admin/daily-user-report",
  TRANSACTION_REPORT: "admin/transactions-report",

  //rewards
  REWARDS: "admin/referral-listing",
  REFFERED_PAYOUT: "admin/referrals-payout-listing",
  REFFERED_STATUS: "admin/referrals-payout-change-status",
  REWARDS_DETAILS: "admin/referrals-payout-details",
  REWARDS_DETAILS_LIST: "admin/referrals-payout-referred-listing",
  REWARDS_DOWNLOAD: "admin/referral-rewards/download",
  REWARDS_PAYOUT_DOWNLOAD: "admin/referrals-payout/download",
  REWARDS_REFFERED_DOWNLOAD: "admin/referrals-payout-referred/download",

  //privacy policy
  PRIVACY_POLICY_STATIC:
    "static-page/details/ab9e4da9-4ef1-4656-88e6-d5956227297d",
  TERMS_AND_CONDITIONS_STATIC:
    "static-page/details/f83b19ac-f019-4ebc-8b70-fc39cbc0c6ab",
};
